import React, { useState, useEffect } from 'react';
import '../styles/landingpage.css';
import matching_profile from "../assets/landingpage/matching_profile.png";
import profiles_viewed from "../assets/landingpage/profiles_viewed.png";
import membership_expiry from "../assets/landingpage/memebership_expiry.png";
import memebership_plan from "../assets/landingpage/memebership_plan.png";
import { getJson } from "../network/api";
import { ApiEndpoints } from "../network/config";

import banner1 from "../assets/landingpage/landing1.jpg";
import banner2 from "../assets/landingpage/landing2.jpg";
import banner3 from "../assets/landingpage/landing3.jpg";
import banner4 from "../assets/landingpage/landing4.jpg";
import banner5 from "../assets/landingpage/landing5.jpg";
const LandingPage = () => {
  const images = [banner1, banner2, banner3, banner4, banner5];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const userId = sessionStorage.getItem("userId");
  const [dashboard, setDashboard] = useState({});


  const [userName, setUserName] = useState("");

  useEffect(() => {
    const name = sessionStorage.getItem("userName");

    if (name && name.trim() !== "") {
      setUserName(name);
    } else {
      setUserName("User"); 
    }
  }, []);
 useEffect(() => {
  const interval = setInterval(() => {
    setCurrentImageIndex(prev => (prev + 1) % images.length);
  }, 7000);

  return () => clearInterval(interval);
}, []);
  useEffect(() => {
  const userId = sessionStorage.getItem("userId");
  if (!userId) return;

  const fetchData = async () => {
    try {
      const res = await getJson(`${ApiEndpoints.getDashboardData}/${userId}`);
      if (res?.data) setDashboard(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  fetchData();
}, []);



  const handleNext = () => {
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <div className="landing-container">
      
      {/* 👇 Dynamic User Name */}
      <div className="main-text">
        Welcome Back, {userName}
      </div>

      <div className="boxes-container">
        <div className="box">
          <div className="box-content">
            <h3>{dashboard.totalProfilesSelected}/{dashboard.totalProfilesAllowed}</h3>
            <p>PROFILES VIEWED</p>
          </div>
          <div className="box-icon">
            <img src={profiles_viewed} alt="Profiles viewed" />
          </div>
        </div>

        <div className="box">
          <div className="box-content">
            <h3>{dashboard.matchingProfilesCount}</h3>
            <p>MATCHING PROFILES AVAILABLE</p>
          </div>
          <div className="box-icon">
            <img src={matching_profile} alt="Matching profile" />
          </div>
        </div>

        

        <div className="box">
          <div className="box-content">
            <h3>{dashboard.planAmount}</h3>
<p>{dashboard.planName} - {dashboard.totalProfilesAllowed} PROFILES</p></div>
          <div className="box-icon">
            <img src={memebership_plan} alt="Membership plan" />
          </div>
        </div>

        <div className="box">
          <div className="box-content">
            <h3>{dashboard.remainingDays} DAYS</h3>
            <p>MEMBERSHIP EXPIRY</p>
          </div>
          <div className="box-icon">
            <img src={membership_expiry} alt="Membership expiry" />
          </div>
        </div>
      </div>

      {/* Image Slider */}
     <div className="image-slider">
  <div
    className="slider-track"
    style={{
      transform: `translateX(-${currentImageIndex * 100}%)`
    }}
  >
    {images.map((img, index) => (
      <img key={index} src={img} alt="Slide" className="slide-image" />
    ))}
  </div>

  <div className="slider-arrow arrow-left" onClick={handlePrev}>&#10094;</div>
  <div className="slider-arrow arrow-right" onClick={handleNext}>&#10095;</div>
</div>

    </div>
  );
};

export default LandingPage;
